import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RecrawlContextDocuments as RecrawlContextDocumentsMutation,
    RecrawlContextDocumentsVariables as RecrawlContextDocumentsMutationVariables,
    ContextDocumentRecrawlInput,
} from 'nutshell-graphql-types';

import RECRAWL_CONTEXT_DOCUMENT from '../mutations/recrawl-context-documents.graphql';

export const useRecrawlContextDocuments = (): {
    recrawlContextDocuments: (input: ContextDocumentRecrawlInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [recrawlContextDocumentsMutation, {loading, error}] = useMutation<
        RecrawlContextDocumentsMutation,
        RecrawlContextDocumentsMutationVariables
    >(RECRAWL_CONTEXT_DOCUMENT);

    return {
        recrawlContextDocuments: (input: ContextDocumentRecrawlInput) => {
            return recrawlContextDocumentsMutation({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
